<template>
	<CDialog
		:visible="true"
		:close-on-click-modal="true"
		:show-close="true"
		max-width="450px"
		@closed="$emit('closed')"
	>
		<div class="linked-lookup-sync-progress text-center mt-1 mb-3">
			<Inline class="sync-icon" svg="complex-icons/lookup-field"></Inline>

			<!-- Error state -->
			<template v-if="failed">
				<h2 class="sync-progress__header font-display text-6 font-bold mt-1 mb-4">
					Sync Failed
				</h2>
				<CCallout type="error" class="text-left">
					There was a problem updating linked lookups.
				</CCallout>
			</template>

			<!-- Completed state -->
			<template v-else-if="completed">
				<h2 class="sync-progress__header font-display text-6 font-bold mt-1 mb-4">
					Sync Complete
				</h2>
				<CCallout type="success" class="text-left">
					Linked lookups have been updated successfully.
				</CCallout>
			</template>

			<!-- Progress state -->
			<template v-else>
				<h2 class="sync-progress__header font-display text-6 font-bold mt-1 mb-4">
					Updating Linked Lookups
				</h2>

				<div class="relative">
					<CProgressBar
						class="mb-4"
						:value="progressPercentage"
					/>
					<div
						v-if="progressPercentage === 0"
						class="absolute inset-0 flex items-center justify-center"
					>
						<Inline svg="loading" class="spin" />
					</div>
				</div>

				<div v-if="totalEntries > 0" class="sync-progress__subtext text-muted">
					Updating {{ completedEntries?.toLocaleString() || 0 }} of {{ totalEntries?.toLocaleString() || 0 }} entries...
				</div>
			</template>
		</div>
	</CDialog>
</template>

<script lang="ts">
	import { defineComponent, computed } from 'vue';
	import CDialog from './Dialog.vue';
	import CProgressBar from 'src/components/info/ProgressBar.vue';
	import CCallout from 'src/components/content/Callout.vue';

	export default defineComponent({
		components: {
			CDialog,
			CProgressBar,
			CCallout
		},
		props: {
			progress: {
				type: Number,
				default: 0
			},
			totalEntries: {
				type: Number,
				default: 0
			},
			completedEntries: {
				type: Number,
				default: 0
			},
			failed: {
				type: Boolean,
				default: false
			},
			completed: {
				type: Boolean,
				default: false
			}
		},
		emits: ['closed'],
		setup(props) {
			const progressPercentage = computed(() => {
				if (props.progress != null) {
					return props.progress;
				}
				if (props.totalEntries > 0) {
					return (props.completedEntries / props.totalEntries) * 100;
				}
				return 0;
			});

			return {
				progressPercentage
			};
		}
	});
</script>

<style lang="scss">
	.linked-lookup-sync-progress {
		padding: 2rem 1rem;
	}

	.sync-icon {
		display: block;
		max-width: 150px;
		max-height: 150px;
		margin: 0 auto;
	}

	.sync-progress__header {
		margin-top: 1.5rem;
	}

	.sync-progress__subtext {
		font-size: .9rem;
	}
</style>
